import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { VolumeSetList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { VolumeSetCreateInitializer } from "./create/initializer";

const VolumeSetRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<VolumeSetList />} />
        <Route path={`-create/*`} element={<VolumeSetCreateInitializer />} />
      </Routes>
    </Layout>
  );
};

export default VolumeSetRoute;
